import { atom } from 'recoil';

export const ContactUsPopupState = atom({
  key: 'ContactUsPopupState',
  default: false,
});
